import { defaultTheme } from '@agro-club/agroclub-shared'
import { isRussia } from 'env'
import { Deal, DealStatusTypes } from 'modules/domain/deal/types'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'react-responsive'
import styled from 'styled-components'
import { Card } from 'views/components/Card/Card'
import { KeyValue } from 'views/components/KeyValue/KeyValue'
import { useDealContext } from '../DealContext'
import { ExecutorsModal } from '../DealEditModals/ExecutorsModal/ExecutorsModal'
import { Logisticians } from './Logisticians'
import { Regionals } from './Regionals'

const ExecutorsList: FC<{ deal: Deal }> = ({ deal }) => {
  const { t } = useTranslation('executors')
  const getName = (data) => `${data.full_name}${data.is_active ? '' : t('common:deactivated')}`

  const isMobile = useMediaQuery({
    query: `(max-width: ${defaultTheme.queries.mobile})`,
  })

  const isHorizontal = isMobile ? false : true

  return (
    <>
      <KeyValue
        horizontal={isHorizontal}
        label={t(`user_coordinator`)}
        columnGap="medium"
        labelTypo="bodyMedium"
        valueTypo="bodyLarge"
      >
        {deal.executors?.user_coordinator ? getName(deal.executors.user_coordinator) : t('not_selected')}
      </KeyValue>

      <Logisticians deal={deal} />

      <KeyValue
        horizontal={isHorizontal}
        label={t(`deal_coordinator`)}
        columnGap="medium"
        labelTypo="bodyMedium"
        valueTypo="bodyLarge"
      >
        {deal.executors?.deal_coordinator ? getName(deal.executors.deal_coordinator) : t('not_selected')}
      </KeyValue>

      <KeyValue
        horizontal={isHorizontal}
        label={t(`trader`)}
        columnGap="medium"
        labelTypo="bodyMedium"
        valueTypo="bodyLarge"
      >
        {deal.executors?.trader ? getName(deal.executors.trader) : t('not_selected')}
      </KeyValue>

      <KeyValue
        horizontal={isHorizontal}
        label={t(`shipment_coordinator`)}
        columnGap="medium"
        labelTypo="bodyMedium"
        valueTypo="bodyLarge"
      >
        {deal.executors?.shipment_coordinator ? getName(deal.executors.shipment_coordinator) : t('not_selected')}
      </KeyValue>

      {isRussia && <Regionals deal={deal} />}
    </>
  )
}

const StyledCardContainer = styled(Card.Container)`
  @media (max-width: ${defaultTheme.queries.mobile}) {
    border-radius: 16px;
  }
`

export const DealExecutorsBlock: FC = () => {
  const { deal } = useDealContext()
  const [editModalIsOpen, setEditModalIsOpen] = useState(false)
  if (deal.status == DealStatusTypes.DRAFT) {
    return null
  }

  return (
    <StyledCardContainer bordered disableShadow padding="compact">
      <Card.GapableContent>
        <Card.Grid cols={2} rowGap={4} columnGap={4}>
          <ExecutorsList deal={deal} />
        </Card.Grid>

        {editModalIsOpen && <ExecutorsModal onClose={() => setEditModalIsOpen(false)} />}
      </Card.GapableContent>
      <Card.EditButton id="editExecutors" onClick={() => setEditModalIsOpen(true)} />
    </StyledCardContainer>
  )
}
